import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function AdminDashboard() {
  const { t } = useI18n();
  const [stats, setStats] = useState({});

  useEffect(() => {
    api.get("/admin/stats")
      .then((r) => setStats(r.data))
      .catch(() => { /* silenced — the global axios interceptor handles 401 redirects */ });
  }, []);

  const cards = [
    { key: "games", label: t("games"), color: "from-sky-500 to-sky-600" },
    { key: "questions", label: t("questions"), color: "from-amber-500 to-orange-500" },
    { key: "credentials", label: t("credentials"), color: "from-rose-500 to-pink-500" },
    { key: "competition_attempts", label: t("competition"), color: "from-purple-500 to-indigo-500" },
    { key: "training_results", label: t("training"), color: "from-emerald-500 to-teal-500" },
    { key: "inscriptions", label: t("school_register"), color: "from-yellow-500 to-amber-500" },
  ];

  return (
    <div>
      <h1 className="text-3xl font-[Outfit] font-semibold text-slate-900 mb-8" data-testid="admin-dashboard-title">{t("dashboard")}</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {cards.map((c) => (
          <div key={c.key} className={`bg-gradient-to-br ${c.color} rounded-2xl p-5 text-white shadow-md`} data-testid={`stat-${c.key}`}>
            <div className="text-[10px] uppercase tracking-[0.25em] font-bold opacity-80">{c.label}</div>
            <div className="font-[Outfit] text-4xl font-bold mt-2">{stats[c.key] ?? "-"}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
